// eslint-disable-next-line
import tw, { styled } from "twin.macro";
import React from "react";

const Card = styled.div`
  .Back__Card {
    opacity: 0;
  }

  &:hover {
    .Back__Card {
      transition: opacity 300ms ease-in;
      opacity: 1;
    }
  }
`;

const EnterpriseCard = ({ title, icon, description, tech }) => {
  return (
    <Card tw="relative  bg-gradient-to-r from-gray-600  to-gray-700  text-white! shadow-lg rounded-tr-3xl rounded-bl-3xl  border-l-0 border-r-0 border-b-0 	border-red-600 border-solid hover:(shadow-2xl border-white border-t-2  border-solid) transition-all duration-200 ease-in-out text-center p-5 hover:(transform scale-105) ">
      <img tw="h-20 mx-auto" src={icon} alt={title} />
      <p className="card__title" tw="text-2xl font-bold">
        {title}
      </p>
      <p tw="max-w-xs my-20"> {description} </p>

      {/* Back Card */}

      <div
        className="Back__Card"
        tw="absolute  w-full h-full bg-red-600 text-white rounded-tr-3xl rounded-bl-3xl left-0 top-0 text-center"
      >
        <div tw="p-5 h-full">
          <img tw="h-20 mx-auto" src={icon} alt={title} />

          <p tw="text-2xl font-bold">{title}</p>

          <div tw="flex justify-center items-center h-1/2">
            <div tw="space-y-5 text-left">
              {tech.map((item, index) => (
                <p tw="leading-3	" key={index}>
                  {"> "}
                  {item}{" "}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default EnterpriseCard;
